<template>
  <div class="card card-timeline card-plain">
    <div class="card-body">
      <ul class="timeline" :class="{'timeline-simple': type === 'simple'}">
        <slot></slot>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'time-line',
  props: {
    type: {
      type: String,
      default: '',
      description: 'Timeline type (simple|"")'
    }
  }
}
</script>
<style scoped>
  .card-timeline .timeline {
    list-style: none;
    padding: 20px 0 20px;
    position: relative;
  }

  .card-timeline .timeline:before {
    top: 0;
    bottom: 0;
    position: absolute;
    content: " ";
    width: 3px;
    background-color: #78909c;
    left: 50%;
    margin-left: -1.5px;
  }

  .card-timeline .timeline .timeline-footer .btn {
    margin: 0;
  }

  .card-timeline .timeline h6 {
    color: #37474f;
    font-weight: 400;
    margin: 10px 0px 0px;
  }

  .card-timeline .timeline.timeline-simple:before {
    left: 5%;
  }

  .card-timeline .timeline.timeline-simple > li > .timeline-panel {
    width: 86%;
  }

  .card-timeline .timeline.timeline-simple > li > .timeline-badge {
    left: 5%;
  }

  .card-timeline .timeline > li {
    margin-bottom: 20px;
    position: relative;
  }

  .card-timeline .timeline > li:before, .card-timeline .timeline > li:after {
    content: " ";
    display: table;
  }

  .card-timeline .timeline > li:after {
    clear: both;
  }

  .card-timeline .timeline > li > .timeline-panel {
    width: 45%;
    float: left;
    padding: 20px;
    border-radius: 5px;
    box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
    background-color: #fff;
    color: #000;
    margin-bottom: 20px;
    position: relative;
  }

  .card-timeline .timeline > li > .timeline-panel:before {
    position: absolute;
    top: 26px;
    right: -15px;
    display: inline-block;
    border-top: 15px solid transparent;
    border-left: 15px solid #f5f7f8;
    border-right: 0 solid #f5f7f8;
    border-bottom: 15px solid transparent;
    content: " ";
  }

  .card-timeline .timeline > li > .timeline-panel:after {
    position: absolute;
    top: 27px;
    right: -14px;
    display: inline-block;
    border-top: 14px solid transparent;
    border-left: 14px solid #fff;
    border-right: 0 solid #fff;
    border-bottom: 14px solid transparent;
    content: " ";
  }

  .card-timeline .timeline > li > .timeline-badge {
    color: #fff;
    width: 50px;
    height: 50px;
    text-align: center;
    position: absolute;
    top: 16px;
    left: 50%;
    margin-left: -25px;
    background-color: #37474f;
    z-index: 100;
    border-top-right-radius: 50%;
    border-top-left-radius: 50%;
    border-bottom-right-radius: 50%;
    border-bottom-left-radius: 50%;
    border: 3px solid #f4f3ef;
  }

  .card-timeline .timeline > li > .timeline-badge [class^="fa-"], .card-timeline .timeline > li > .timeline-badge [class*=" fa-"] {
    line-height: inherit;
  }

  .card-timeline .timeline > li > .timeline-badge .nc-icon {
    line-height: 2.1;
    width: 25px;
    text-align: center;
    font-size: 21px;
  }

  .card-timeline .timeline > li.timeline-inverted > .timeline-panel {
    float: right;
    background-color: #fff;
  }

  .card-timeline .timeline > li.timeline-inverted > .timeline-panel:before {
    border-left-width: 0;
    border-right-width: 15px;
    left: -15px;
    right: auto;
  }

  .card-timeline .timeline > li.timeline-inverted > .timeline-panel:after {
    border-left-width: 0;
    border-right-width: 14px;
    left: -14px;
    right: auto;
  }

  .card-timeline .timeline-heading {
    margin-bottom: 15px;
  }

  .card-timeline .timeline-badge.primary {
    background-color: #1f8ed5 !important;
  }

  .card-timeline .timeline-badge.info {
    background-color: #1f8ed5 !important;
  }

  .card-timeline .timeline-badge.success {
    background-color: #40b539 !important;
  }

  .card-timeline .timeline-badge.warning {
    background-color: #fdb611 !important;
  }

  .card-timeline .timeline-badge.danger {
    background-color: #e7161a !important;
  }

  .card-timeline .timeline-title {
    margin-top: 0;
    color: inherit;
  }

  .card-timeline .timeline-body > p, .card-timeline .timeline-body > ul {
    margin-bottom: 0;
  }

  .card-timeline .timeline-body > p + p {
    margin-top: 5px;
  }
</style>
